module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "user-table-container"
  }, [_c('table', {
    staticClass: "user-table"
  }, [_c('thead', [_c('tr', [_c('th', {
    staticClass: "th-sorter name",
    class: {
      active: _vm.sortKey === 'name'
    },
    attrs: {
      "rowspan": "3"
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('name')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.name')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), _c('th', {
    staticClass: "working-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.work_hours')))])]), _vm._v(" "), (_vm.isShowRestColumnFinal) ? _c('th', {
    staticClass: "rest-hours",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v("Rest")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "teaching-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.teaching')))])]), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
    staticClass: "task-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.tasks')))])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? _c('th', {
    staticClass: "prep-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_vm._v("\n        " + _vm._s(_vm.$t('vue2.assign_users_hours.preparation')) + "\n      ")]) : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? _c('th', {
    staticClass: "prep-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_vm._v("\n        " + _vm._s(_vm.localPoolTitle) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "absence-hours",
    attrs: {
      "colspan": "1"
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.absence')))]), _vm._v(" "), _c('th', {
    staticClass: "sub-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.substitute_hours')))]), _vm._v(" "), (_vm.isSFOActive) ? _c('th', {
    staticClass: "club-hours",
    attrs: {
      "colspan": _vm.numberOfCols
    }
  }, [_c('div', [_vm._v(_vm._s(_vm.$t('vue2.task_overview.club')))])]) : _vm._e()]), _vm._v(" "), _c('tr', [(_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter assigned_total_hours",
    class: {
      active: _vm.sortKey === 'assigned_total_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('assigned_total_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_total_hours",
    class: {
      active: _vm.sortKey === 'actual_total_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_total_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_total_hours",
    class: {
      active: _vm.sortKey === 'diff_total_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_total_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isShowRestColumnFinal) ? _c('th', {
    staticClass: "th-sorter rest_hours",
    class: {
      active: _vm.sortKey === 'rest_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('rest_hours')
      }
    }
  }, [_vm._m(0)]) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter assigned_teaching_hours",
    class: {
      active: _vm.sortKey === 'assigned_teaching_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('assigned_teaching_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_teaching_hours",
    class: {
      active: _vm.sortKey === 'actual_teaching_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_teaching_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_teaching_hours",
    class: {
      active: _vm.sortKey === 'diff_teaching_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_teaching_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter assigned_additional_task_hours",
    class: {
      active: _vm.sortKey === 'assigned_additional_task_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('assigned_additional_task_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_additional_task_hours",
    class: {
      active: _vm.sortKey === 'actual_additional_task_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_additional_task_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_additional_task_hours",
    class: {
      active: _vm.sortKey === 'diff_additional_task_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_additional_task_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter assigned_preparation_hours",
    class: {
      active: _vm.sortKey === 'assigned_preparation_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('assigned_preparation_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_preparation_hours",
    class: {
      active: _vm.sortKey === 'actual_preparation_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_preparation_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_preparation_hours",
    class: {
      active: _vm.sortKey === 'diff_preparation_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_preparation_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter assigned_pool_hours",
    class: {
      active: _vm.sortKey === 'assigned_pool_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('assigned_pool_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_pool_hours",
    class: {
      active: _vm.sortKey === 'actual_pool_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_pool_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_pool_hours",
    class: {
      active: _vm.sortKey === 'diff_pool_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_pool_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e()] : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_absence_hours",
    class: {
      active: _vm.sortKey === 'actual_absence_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_absence_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter substitute_pool_hours",
    class: {
      active: _vm.sortKey === 'substitute_pool_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('substitute_pool_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_substitute_hours",
    class: {
      active: _vm.sortKey === 'actual_substitute_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_substitute_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_substitute_hours",
    class: {
      active: _vm.sortKey === 'diff_substitute_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_substitute_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter assigned_club_hours",
    class: {
      active: _vm.sortKey === 'assigned_club_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('assigned_club_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.assigned')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "th-sorter actual_club_hours",
    class: {
      active: _vm.sortKey === 'actual_club_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('actual_club_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.scheduled')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('th', {
    staticClass: "th-sorter diff_club_hours",
    class: {
      active: _vm.sortKey === 'diff_club_hours'
    },
    on: {
      "click": function($event) {
        return _vm.sortBy('diff_club_hours')
      }
    }
  }, [_c('div', {
    staticClass: "column-width"
  }, [_vm._v(_vm._s(_vm.$t('vue2.assign_users_hours.diff')) + "\n            "), _c('span', {
    staticClass: "icon-menu-open"
  })])]) : _vm._e()] : _vm._e()], 2)]), _vm._v(" "), _c('tbody', {
    staticClass: "user-table__body"
  }, _vm._l((_vm.filteredData), function(user) {
    return _c('tr', {
      key: user.id,
      staticClass: "tr-user",
      class: {
        'tr-user--cant-edit': !_vm.theUserCanManageAssignedHours || (_vm.isPoolsDeactivated && !_vm.isAssignedPoolFromNormWhenPoolsDeactivated)
      }
    }, [_c('th', {
      staticClass: "tr-user__name"
    }, [_c('div', {
      staticClass: "tr-user__name__inner"
    }, [_c('p', [_vm._v(_vm._s(user.name))]), _vm._v(" "), _c('div', {
      staticClass: "tr-user__name__bttn icon__bg-circle hint--right",
      attrs: {
        "aria-label": _vm.$t('vue2.task_overview.task_and_hour_overview')
      },
      on: {
        "click": function($event) {
          return _vm.setTheUserToShowTasksFor(user)
        }
      }
    }, [_c('svg', {
      staticClass: "icon-chart tw-icon tw-icon--small",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24"
      }
    }, [_c('path', {
      staticClass: "primary",
      attrs: {
        "d": "M5 3h14a2 2 0 0 1 2 2v14a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5c0-1.1.9-2 2-2zm11 4a1 1 0 0 0-1 1v8a1 1 0 0 0 2 0V8a1 1 0 0 0-1-1z"
      }
    }), _vm._v(" "), _c('path', {
      staticClass: "secondary",
      attrs: {
        "d": "M8 11a1 1 0 0 1 1 1v4a1 1 0 0 1-2 0v-4a1 1 0 0 1 1-1zm4-2a1 1 0 0 1 1 1v6a1 1 0 0 1-2 0v-6a1 1 0 0 1 1-1z"
      }
    })])])])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return !_vm.isDatesPristine; }
        }),
        expression: "{\n                  arrow: true,\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window',\n                  onShow: () => !isDatesPristine\n                }"
      }],
      staticClass: "number number_edit td-presence",
      class: {
        'is-number--calculated': !_vm.isDatesPristine
      },
      attrs: {
        "content": _vm.createTooltip(user.assigned_total_hours)
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.assigned_total_hours, 'assigned_total_hours', $event)
        }
      }
    }, [(!_vm.isDatesPristine) ? _c('span', {
      staticClass: "icon-clock"
    }) : _vm._e(), _vm._v("\n        " + _vm._s(user.v_total_hours_assigned_in_period) + "\n      ")]) : _vm._e(), _vm._v(" "), _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          placement: 'right',
          arrow: true,
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window',
          onShow: function () { return user.vIsPedagogog === true; }
        }),
        expression: "{\n                  placement: 'right',\n                  arrow: true,\n                  animateFill: false,\n                  animation : 'shift-away',\n                  zIndex: '999999992',\n                  boundary: 'window',\n                  onShow: () => user.vIsPedagogog === true\n                }"
      }],
      staticClass: "number td-presence",
      class: {
        'td-presence--pedagog': user.vIsPedagogog
      },
      attrs: {
        "aria-label": user.actual_total_hours,
        "content": "For pædagoger tælles arbejdstid som summen af alle skemalagte timer i kalenderen – uanset om de er sat som undervisning, SFO, vikar eller andre opgaver."
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number td-presence number__scale-indicator",
      style: (_vm.scaleIndicator(user.diff_total_hours)),
      attrs: {
        "aria-label": user.diff_total_hours
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isShowRestColumnFinal) ? _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          content: ("<div>\n                    <div class='do-flex-labels'>Arbejdstid: <span>" + (user.assigned_total_hours) + "</span></div>\n                    <div class='do-flex-labels'>Tildelte timer: <span>" + (user.sum_hours) + "</span></div>\n                  </div>"),
          allowHTML: true,
          arrow: true,
          placement: 'left'
        }),
        expression: "{\n        content: `<div>\n                    <div class='do-flex-labels'>Arbejdstid: <span>${user.assigned_total_hours}</span></div>\n                    <div class='do-flex-labels'>Tildelte timer: <span>${user.sum_hours}</span></div>\n                  </div>`,\n        allowHTML: true,\n        arrow: true,\n        placement: 'left'\n      }"
      }],
      staticClass: "number pointer td-rest number__scale-indicator",
      style: (_vm.scaleIndicator(user.rest_hours)),
      attrs: {
        "aria-label": user.rest_hours
      }
    }) : _vm._e(), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number_edit td-teaching",
      attrs: {
        "aria-label": user.assigned_teaching_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.assigned_teaching_hours, 'assigned_teaching_hours', $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number td-teaching",
      attrs: {
        "aria-label": user.actual_teaching_hours
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number__scale-indicator td-teaching",
      style: (_vm.scaleIndicator(user.diff_teaching_hours)),
      attrs: {
        "aria-label": user.diff_teaching_hours
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number_edit td-tasks",
      attrs: {
        "aria-label": user.assigned_additional_task_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.assigned_additional_task_hours, 'assigned_additional_task_hours', $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number td-tasks",
      attrs: {
        "aria-label": user.actual_additional_task_hours
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number__scale-indicator td-tasks",
      style: (_vm.scaleIndicator(user.diff_additional_task_hours)),
      attrs: {
        "aria-label": user.diff_additional_task_hours
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isSchoolYearWithNewEmploymentDeal) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          content: _vm.getPrepFactorTooltipContent(user),
          arrow: true,
          placement: 'top',
          onShow: function () { return _vm.isShowPrepFactorCalculation; }
        }),
        expression: "{\n        content: getPrepFactorTooltipContent(user),\n        arrow: true,\n        placement: 'top',\n        onShow: () => isShowPrepFactorCalculation\n      }"
      }],
      staticClass: "number number_edit td-preparation",
      attrs: {
        "aria-label": user.assigned_preparation_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.assigned_preparation_hours, 'assigned_preparation_hours', $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number td-preparation",
      attrs: {
        "aria-label": user.actual_preparation_hours
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number__scale-indicator td-preparation",
      style: (_vm.scaleIndicator(user.diff_preparation_hours)),
      attrs: {
        "aria-label": user.diff_preparation_hours
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), (_vm.isLocalPoolActivated) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number_edit td-preparation",
      attrs: {
        "aria-label": user.assigned_pool_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.assigned_pool_hours, 'assigned_pool_hours', $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number td-preparation",
      attrs: {
        "aria-label": user.actual_pool_hours
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number__scale-indicator td-preparation",
      style: (_vm.scaleIndicator(user.diff_pool_hours)),
      attrs: {
        "aria-label": user.diff_pool_hours
      }
    }) : _vm._e()] : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number pointer td-absence",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setActiveUserFor(user, 'absence')
        }
      }
    }, [_c('div', {
      staticClass: "tr-user__text"
    }, [_vm._v("\n          " + _vm._s(user.actual_absence_hours) + "\n        ")])]), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number_edit td-sub-hours",
      attrs: {
        "aria-label": user.substitute_pool_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.substitute_pool_hours, 'substitute_pool_hours', $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number pointer td-sub-hours",
      attrs: {
        "aria-label": user.actual_substitute_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setActiveUserFor(user, 'substituteHours')
        }
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number__scale-indicator td-sub-hours",
      style: (_vm.scaleIndicator(user.diff_substitute_hours)),
      attrs: {
        "aria-label": user.diff_substitute_hours
      }
    }) : _vm._e(), _vm._v(" "), (_vm.isSFOActive) ? [(_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number_edit td-club",
      attrs: {
        "aria-label": user.assigned_club_hours
      },
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.openEditFromRow(user, user.assigned_club_hours, 'assigned_club_hours', $event)
        }
      }
    }) : _vm._e(), _vm._v(" "), _c('td', {
      staticClass: "number td-club",
      attrs: {
        "aria-label": user.actual_club_hours
      }
    }), _vm._v(" "), (_vm.viewSettings.show_assigned.active) ? _c('td', {
      staticClass: "number number__scale-indicator td-club",
      style: (_vm.scaleIndicator(user.diff_club_hours)),
      attrs: {
        "aria-label": user.diff_club_hours
      }
    }) : _vm._e()] : _vm._e()], 2)
  }), 0)]), _vm._v(" "), (_vm.theEditNumberUserId) ? _c('div', {
    ref: "popper_child",
    staticClass: "popper_child"
  }, [_c('transition', {
    attrs: {
      "name": "scale"
    }
  }, [(_vm.isDropdownPopperDone) ? _c('div', {
    staticClass: "number__input-opened"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.lazy",
      value: (_vm.theEditNumberNumber),
      expression: "theEditNumberNumber",
      modifiers: {
        "lazy": true
      }
    }, {
      name: "focus",
      rawName: "v-focus"
    }, {
      name: "on-clickaway",
      rawName: "v-on-clickaway",
      value: (_vm.closeEditing),
      expression: "closeEditing"
    }],
    attrs: {
      "type": "number"
    },
    domProps: {
      "value": (_vm.theEditNumberNumber)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.doneEditing.apply(null, arguments)
      },
      "change": function($event) {
        _vm.theEditNumberNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('button', {
    staticClass: "bttn bttn--primary",
    class: {
      'bttn--small--loading': _vm.isUpdatingNumber
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.doneEditing.apply(null, arguments)
      }
    }
  }, [(!_vm.isUpdatingNumber) ? _c('span', [_vm._v(_vm._s(_vm.$t('vue2.common.save')))]) : _vm._e()])]) : _vm._e()])], 1) : _vm._e()])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "column-width"
  }, [_vm._v("Rest\n          "), _c('span', {
    staticClass: "icon-menu-open"
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-105dd92a!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AssignHours/AssignHoursAllUsersFlat.vue
// module id = 1762
// module chunks = 1